import {
	USER_LOADED,
	AUTH_ERROR,
	LOGIN_SUCCESS,
	LOGIN_FAIL,
	LOGOUT,
	LOGIN_LOADING
} from "../actions/actionTypes";

const initialState = {
	sessionTimeout: false,
	accessToken: localStorage.getItem("accessToken"),
	isAuthenticated: null,
	loading: true,
	user: null,
	refresh_token_loading:false
};

export default function authReducer(state = initialState, action) {
	const { type, payload } = action;

	switch (type) {
		case USER_LOADED:
			return {
				...state,
				isAuthenticated: true,
				loading: false,
				user: payload,
				sessionTimeout: false,
				refresh_token_loading: false
			};
		case LOGIN_LOADING:
			return {
				...state,
				refresh_token_loading: true
			};
		case LOGIN_SUCCESS:
			localStorage.setItem("accessToken", payload.accessToken);
			return {
				...state,
				...payload,
				isAuthenticated: true,
				loading: false,
				sessionTimeout: false,
				refresh_token_loading: false
			};

		case AUTH_ERROR:
			localStorage.removeItem("accessToken");
			return {
				...state,
				sessionTimeout: true,
				accessToken: null,
				isAuthenticated: false,
				loading: false,
				user: null,
				refresh_token_loading: false
			};
		case LOGIN_FAIL:
		case LOGOUT:
			localStorage.removeItem("accessToken");
			return {
				...state,
				accessToken: null,
				isAuthenticated: false,
				loading: false,
				user: null,
				sessionTimeout: false,
				refresh_token_loading: false
			};
		default:
			return state;
	}
}
